document.addEventListener('DOMContentLoaded', function () {
  if (!window.FoxTheme || !window.FoxTheme.Carousel) return;

  document.querySelectorAll('.product-swiper').forEach(function (el) {
    if (el.__initialized) return;
    el.__initialized = true;

    const swiperOptions = {
      slidesPerView: 1,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
        type: 'bullets',
      },
    };

    const instance = new window.FoxTheme.Carousel(el, swiperOptions);
    instance.init();
  });
});